/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, string, number, shape,
} from 'prop-types';
import { connect } from 'react-redux';
import DesktopAddress from './DesktopAddress';
import DesktopAddressSearch from './DesktopAddressSearch';
import { isEmpty } from '../../../utils/object';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;
class DesktopAddressList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recipients: [],
            selectedRecipient: '',
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { recipients, selectedRecipient } = this.props;
        this.setState({ recipients, selectedRecipient });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const {
            recipients, selectedRecipient, addForm,
        } = props;
        this.setState({ recipients });
        if (selectedRecipient) {
            this.setState({ selectedRecipient });
        }
        if (addForm === 'AddForm') {
            this.setState({ selectedRecipient: '' });
        }
    };

    handleSearchRecipientChange = (data) => {
        const { search } = data;
        const { recipients: allRecipients } = this.props;
        const recipients = allRecipients.filter((r) => [
            r.FirstName,
            r.LastName,
            r.EmployerName,
            r.PhoneNumber,
            r.Addresses[0].AddressLineOne,
            r.Addresses[0].AddressLineTwo,
            r.Addresses[0].City,
        ]
            .join(' ')
            .match(new RegExp(search, 'ig')));
        this.setState({ recipients });
    };

    render() {
        const {
            countries,
            recipients: allRecipients,
        } = this.props;

        const { recipients, selectedRecipient } = this.state;
        if (!recipients) return null;
        if (isEmpty(allRecipients)) {
            return (
                <div className="emptyListWrapper">
                    <p className="align-center">
                        You do not have any saved addresses on file.
                    </p>
                </div>
            );
        }
        return (
            <>
                <div className="addressListWrapper">
                    <DesktopAddressSearch
                        className="desktopSearch"
                        onChange={this.handleSearchRecipientChange}
                        desktop
                    />
                    <div className="addressList">
                        {recipients.map((recipient) => (
                            <React.Fragment key={recipient.AddressBookEntryId}>
                                <DesktopAddress
                                    recipient={recipient}
                                    isSelected={selectedRecipient === recipient.AddressBookEntryId}
                                    countries={countries}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}

DesktopAddressList.defaultProps = {
    recipients: [],
    countries: [],
    selectedRecipient: '',
};

DesktopAddressList.propTypes = {
    recipients: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    ContactId: number,
                }),
            ),
        }),
    ),
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    selectedRecipient: string,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        toggleState: newState.toggleState,
        recipients: newState.recipients,
        FirstName: newState.recipient?.FirstName || '',
        LastName: newState.recipient?.LastName || '',
        addForm: newState.addForm,
        selectedRecipient: newState.singleAddressGet?.data?.AddressBookEntryId || '',
        countries: newState.countries,
    };
};

export default connect(
    mapStateToProps,
    null,
)(DesktopAddressList);
